/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../../base/Icon';
import Typography from '../../base/Typography';

export const DynamicCalloutCardContainer = styled.div`
    flex-direction:column;
    padding: 1.5rem;
`;

export const DynamicCalloutArticle = styled.article`
  ${({ theme }) => css`
    position:relative;
    background-color:${theme.colors.neutral.white}
  `}
`;

export const DynamicCalloutCardImage = styled.div`
  ${({ theme, image }) => {
    const medium = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let height;
    if (medium) {
      height = '12.5rem';
    } else {
      height = '10rem';
    }

    return css`
    height: ${height};
    width: 100%;
    background-image: url(${image});
    background-size: cover;
    background-position: center;
    `;
  }
}`;

export const DynamicCalloutCardTypography = styled(Typography)`
  ${({ theme, hasLink }) => {
    const medium = theme.useMediaQuery(theme.breakpoints.up('medium'));

    let paddingBottom;
    if (medium) {
      paddingBottom = '4rem';
    } else {
      paddingBottom = '3rem';
    }

    return css`
    && {
      padding-bottom:${hasLink
    ? paddingBottom
    : '0'};
      `;
  }
}
  }
`;

export const DynamicCalloutVisualLinkTypography = styled(Typography)`
  position:absolute;
  bottom:1rem;
`;

export const DynamicCalloutVisualLinkIcon = styled(Icon)`
  ${({ theme }) => {
    const xsmall = theme.useMediaQuery(theme.breakpoints.up('xsmall'));
    const medium = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const xlarge = theme.useMediaQuery(theme.breakpoints.up('xlarge'));
    let bottom;

    if (xsmall) {
      bottom = 0;
    }
    if (medium) {
      bottom = '0.05rem';
    }
    if (xlarge) {
      bottom = '0.1rem';
    }

    return css`
    margin-left:0.5rem;
    margin-bottom: ${bottom};
    `;
  }
}`;

export const DynamicCalloutArticleFlag = styled.span`
  ${({ flagColor }) => css`
    position: absolute;
    display: inline-flex;
    height: 1.6rem;
    align-items: center;
    padding: 0.8rem;
    background-color: ${flagColor};
    z-index: 1;
    border-radius: 0 0 1px 0;
    ::after {
      position: absolute;
      top: 0;
      right: -1.2rem;
      border-bottom: 1.6rem solid transparent;
      border-left: 1.25rem solid ${flagColor};
      content: '';
    }
  `}
`;

export const DynamicCalloutArticleFlagTypography = styled(Typography)`
  ${() => css`
    && {
      font-size:${rem('12px')};
      text-transform:uppercase;
      }
    }
  `}
`;

export const DynamicCalloutBannerImage = styled.div`
  ${({ theme, image }) => {
    const medium = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let minHeight;
    let maxWidth;

    if (medium) {
      minHeight = '8.75rem';
      maxWidth = '12rem';
    } else {
      minHeight = '7.2rem';
      maxWidth = 'none';
    }

    return css`
      min-height: ${minHeight};
      max-width: ${maxWidth};
      height: 100%;
      width: 100%;
      background-image: url(${image});
      background-size: cover;
      background-position: center;
    `;
  }
}`;
